import {EnvironmentTypes} from '../app/Enums/environment-types';

export const environment = {
    tenant: EnvironmentTypes.MSS,
    production: true,
    redirectUri: 'https://arp-ss-app-test.azureedge.net/',
    postLogoutRedirectUri: 'https://arp-ss-app-test.azureedge.net/',
    arpApiUrl: 'https://arp-ss-api-test.azurewebsites.net',
    portalUrl: 'https://arp-portal-test.azureedge.net/?autoredirect=false',
    msalAuthority: 'https://login.microsoftonline.com/a76381c7-ea6e-41f4-8bb8-cb6ec292a8a0',
    msalClientId: '872ae932-56ee-45ad-b826-b479028db6ce',
    authScopes: [
        {
            apiUrl: 'https://arp-ss-api-test.azurewebsites.net/v2_0',
            scope: 'api://50c71e5f-e27c-4ae3-9cc8-53038e3934af/Api.ReadWrite.All'
        }
    ]
};
